<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small @click="goBack" text>
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Atendimento AEE
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card v-if="turma && aluno">
          <v-card-title>Relatório de acompanhamento individual</v-card-title>
          <v-card-text>
            <h4>Turma: {{ turma.descricao }}</h4>
            <h4>Aluno: {{ aluno.nomecompleto }}</h4>
          </v-card-text>
          <v-divider class="mx-4"></v-divider>
          <v-card-title>Professores (diários)</v-card-title>
          <v-card-text>
            <div v-for="diario in gestao_de_aulas" :key="diario.id">
              Professor(a): {{ diario.professor.nome }} | Disciplina:
              {{ diario.disciplina.descricao ? diario.disciplina.descricao : "" }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="space-around">
      <v-col cols="12" md="12">
        <v-sheet cols="12" md="12" elevation="2" class="v-sheet--outlined" rounded>
          <v-lazy>
            <div class="py-2 px-4 text-subtitle-2">Painel de gestão</div>
          </v-lazy>
          <v-divider />
          <v-sheet class="py-2 px-4" md="12">
            <v-row v-if="loadBimestre">
              <v-col class="text-center pt-2" cols="12" md="12">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </v-col>
            </v-row>
            <ValidationObserver v-else v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm">
                <v-row>
                  <v-col class="pt-0 pb-0" cols="12">
                    <ValidationProvider name="Tipo de Aula" rules="required" v-slot="{ errors }">
                      <e-label>Tipo de Aula</e-label>
                      <e-autocomplete
                        :items="$constants.tiposDeAulas"
                        :return-object="false"
                        :error-messages="errors"
                        v-model="form.tipo_de_aula"
                        label="Selecione um tipo de aula"
                        dense
                        solo
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-row v-if="mostrarCampos">
                  <v-col class="pt-0 pb-0" cols="6">
                    <e-label>Escolha um bimestre</e-label>
                    <e-autocomplete
                      :items="$constants.bimestres"
                      :return-object="false"
                      :item-value="(value) => value.value"
                      :item-text="(value) => value.desc"
                      v-model="form.bimestre"
                      @change="onChangeBimestre"
                      label="Selecione uma opção"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col class="pt-0 pb-0" cols="6">
                    <v-dialog
                      ref="dialog"
                      v-model="modal"
                      :return-value.sync="data"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <e-label>Selecione uma data</e-label>
                        <v-text-field
                          v-model="form.data"
                          persistent-hint
                          :disabled="!podeEscolherData"
                          :hint="dicaDaData"
                          label="Escolha uma data"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          dense
                          solo
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="data"
                        :allowed-dates="dataPermitidaNoPlano"
                        locale="pt-BR"
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal = false"> Cancel </v-btn>
                        <v-btn text color="primary" @click="$refs.dialog.save(data)"> OK </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                </v-row>
                <v-row v-if="bimestreEscolhido && !planoDefineDiasEHorarios">
                  <v-col cols="12">
                    <v-alert border="left" type="warning" text>
                      O plano bimestral AEE do
                      <strong>{{ $constants.bimestres[form.bimestre]?.desc }}</strong> ainda não
                      define dias e horários para este aluno. Defina-os no plano antes de lançar o
                      atendimento.
                      <template v-slot:append>
                        <v-btn small color="warning" @click="irParaPlanoBimestral">
                          Abrir plano bimestral
                        </v-btn>
                      </template>
                    </v-alert>
                  </v-col>
                </v-row>

                <v-row v-else-if="diaDaSemanaSelecionado && !diaPrevistoNoPlano">
                  <v-col cols="12">
                    <v-alert border="left" type="warning" text>
                      O plano do
                      <strong>{{ $constants.bimestres[form.bimestre]?.desc }}</strong> não prevê
                      atendimento em <strong>{{ diaDaSemanaSelecionado }}</strong
                      >. Dias previstos: <strong>{{ diasPrevistosNoPlano.join(", ") }}</strong>
                    </v-alert>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="pt-0 pb-0" v-if="form.tipo_de_aula !== 'Aula Remota'" cols="6">
                    <ValidationProvider name="Horário da aula" rules="required" v-slot="{ errors }">
                      <e-label>Selecione um horário</e-label>
                      <e-autocomplete
                        :disabled="!podeEscolherHorario"
                        :items="horariosPermitidos"
                        :error-messages="errors"
                        label="Selecione uma opção"
                        :item-text="(item) => item.descricao"
                        v-model="horarioSelecionado"
                        @change="onChangeHorario"
                        return-object
                        dense
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="6" class="mt-3">
                    <v-alert
                      border="left"
                      color="orange"
                      class="animate__animated animate__headShake"
                    >
                      Você está editando o
                      <strong
                        >{{ $constants.bimestres[form.bimestre]?.desc }} do
                        {{ horarioSelecionado?.descricao }}</strong
                      >
                    </v-alert>
                  </v-col>
                </v-row>
                <v-row v-if="form.bimestre != null && horarioSelecionado">
                  <v-col cols="12">
                    <e-label>Tipo de atendimento realizado </e-label>
                  </v-col>
                  <v-row>
                    <v-col
                      class="py-0 px-5"
                      cols="4"
                      v-for="(el, index) of $constants.tipoDeAtendimentoRealizado"
                      :key="index"
                    >
                      <v-checkbox
                        v-model="form.tipo_atendimento_realizado[index]"
                        :label="el"
                        :value="el"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-row>
                <v-row v-if="form.bimestre != null && horarioSelecionado">
                  <v-col class="d-none">
                    <div v-for="diario in gestao_de_aulas" :key="diario.id">
                      <v-text-field
                        :v-model="
                          (form.disciplina_id = diario.disciplina.id ? diario.disciplina.id : null)
                        "
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col
                    v-for="(el, index) of $constants.aspectosObservados"
                    :key="index"
                    cols="12"
                  >
                    <ValidationProvider :name="el.descricao" rules="required" v-slot="{ errors }">
                      <e-label>{{ el.descricao }}</e-label>
                      <v-textarea
                        rows="3"
                        solo
                        dense
                        v-model="form[el.form]"
                        :error-messages="errors"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-col cols="6" class="mt-4">
                  <v-row>
                    <v-btn
                      block
                      color="primary"
                      :disabled="submittingForm || !horarioSelecionado"
                      :loading="submittingForm"
                      type="submit"
                      >Enviar Relatório</v-btn
                    >
                  </v-row>
                </v-col>
              </form>
            </ValidationObserver>
            <v-alert
              v-if="alert"
              text
              prominent
              type="error"
              class="mt-10 animate__animated animate__headShake"
              icon="mdi-cloud-alert"
            >
              Informe o bimestre
            </v-alert>
          </v-sheet>
          <div></div>
        </v-sheet>
      </v-col>
    </v-row>
  </main-template>
</template>
<script>
function bimestreDaQuery(valor) {
  const bimestre = parseInt(valor, 10);
  return Number.isInteger(bimestre) && bimestre >= 0 && bimestre <= 3 ? bimestre : null;
}

export default {
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      submittingForm: false,
      loadBimestre: false,
      alert: false,
      modal: false,
      form: {
        data: null,
        // vem preenchido quando o usuário chega da tela do plano bimestral
        bimestre: bimestreDaQuery(this.$route.query.bimestre),
        horario_id: null,
        tipo_atendimento_realizado: [],
        matricula_id: parseInt(this.$route.params.matricula_id, 10),
        disciplina_id: null,
      },
      matricula: {},
      turma: {
        descricao: "",
      },
      aluno: {
        nomecompleto: "",
      },
      mostrarCampos: true,
      professor: {},
      diario: {},
      gestao_de_aulas: {
        diario: {
          professor: {
            nome: "",
          },
          disciplina: {
            descricao: "",
            id: null,
          },
        },
      },
      horarios: [],
      horarioSelecionado: {
        descricao: "Escolha um horario",
      },
      data: null,
      planoDoBimestre: null,
    };
  },
  computed: {
    diasEHorariosDoPlano() {
      return this.planoDoBimestre?.dias_horarios ?? [];
    },
    planoDefineDiasEHorarios() {
      return this.diasEHorariosDoPlano.length > 0;
    },
    diasPrevistosNoPlano() {
      return this.diasEHorariosDoPlano.map((item) => item.dia);
    },
    indicesDosDiasPrevistos() {
      return this.diasPrevistosNoPlano
        .map((dia) => this.$constants.diasDaSemana.indexOf(dia))
        .filter((indice) => indice >= 0);
    },
    diaDaSemanaSelecionado() {
      const indice = this.diaDaSemanaDe(this.form.data);
      return indice === null ? null : this.$constants.diasDaSemana[indice];
    },
    diaPrevistoNoPlano() {
      return this.diasPrevistosNoPlano.includes(this.diaDaSemanaSelecionado);
    },
    bimestreEscolhido() {
      return this.form.bimestre !== null && this.form.bimestre !== undefined;
    },
    /**
     * A escolha encadeia tipo de aula -> bimestre com plano -> data -> horário: sem os dias
     * e horários do plano não há opção válida a oferecer.
     */
    podeEscolherData() {
      return Boolean(this.form.tipo_de_aula) && this.planoDefineDiasEHorarios;
    },
    podeEscolherHorario() {
      return this.podeEscolherData && Boolean(this.form.data);
    },
    dicaDaData() {
      if (!this.form.tipo_de_aula) return "Selecione o tipo de aula primeiro";
      if (!this.bimestreEscolhido) return "Selecione o bimestre primeiro";
      if (!this.planoDefineDiasEHorarios) {
        return "Defina os dias e horários no plano bimestral deste aluno";
      }
      return `Dias previstos no plano: ${this.diasPrevistosNoPlano.join(", ")}`;
    },
    /**
     * Computed que devolve função: a identidade muda quando o plano muda, o que força o
     * v-date-picker a reavaliar os dias liberados ao trocar de bimestre.
     */
    dataPermitidaNoPlano() {
      const indicesPrevistos = this.indicesDosDiasPrevistos;
      return (dataISO) =>
        indicesPrevistos.length === 0 || indicesPrevistos.includes(this.diaDaSemanaDe(dataISO));
    },
    /**
     * Cenário 16: só os horários definidos no plano daquele bimestre e, quando já há
     * data escolhida, só os do dia da semana correspondente.
     */
    horariosPermitidos() {
      if (!this.planoDefineDiasEHorarios) return [];

      const idsPermitidos = this.diasEHorariosDoPlano
        .filter((item) => !this.diaDaSemanaSelecionado || item.dia === this.diaDaSemanaSelecionado)
        .map((item) => item.horario_id)
        .filter(Boolean);

      return this.horarios.filter((horario) => idsPermitidos.includes(horario.id));
    },
  },
  mounted() {
    this.loadBasicData(this.form.bimestre, this.form.horario_id);
  },
  watch: {
    data(value) {
      // sem o guard, limpar o picker cairia em new Date(null) e escreveria 01/01/1970
      if (!value) {
        this.form.data = null;
        return;
      }
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(
        new Date(value)
      );
      this.form.data = data_old.replaceAll("/", "/");
      this.descartarSelecoesNaoPermitidas();
    },
  },
  methods: {
    /**
     * Aceita dd/mm/aaaa (exibição) e aaaa-mm-dd (API e v-date-picker).
     * Usa partes locais porque new Date("aaaa-mm-dd") é lido como UTC e volta um dia.
     */
    diaDaSemanaDe(data) {
      if (!data) return null;
      const [a, b, c] = data.split(/[/-]/);
      if (!c) return null;
      const [ano, mes, dia] = data.includes("/") ? [c, b, a] : [a, b, c];
      return new Date(ano, mes - 1, dia).getDay();
    },

    async carregarDadosPreenchidos(bimestre, horario_id) {
      try {
        const response = await this.$services.educacaoInclusivaService.syncAll({
          id: parseInt(this.$route.params.matricula_id, 10),
          bimestre: parseInt(bimestre, 10),
          horario_id: horario_id ?? null,
        });

        // Se não houver uma avaliação existente, limpe os campos do formulário
        if (!response.notas) {
          this.limparCamposFormulario();
        }
      } catch (error) {
        this.$handleError(error);
      }
    },
    limparCamposFormulario() {
      this.form = {
        bimestre: this.form.bimestre, // Mantém o bimestre selecionado
        horario_id: this.form.horario_id, // Mantém o horário selecionado
        tipo_de_aula: this.form.tipo_de_aula,
        data: this.form.data,
        tipo_atendimento_realizado: [],
        matricula_id: parseInt(this.$route.params.matricula_id, 10),
        disciplina_id: null,
        // Outros campos do formulário
      };
    },

    async onChangeBimestre(bimestre) {
      try {
        const horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;
        const response = await this.$services.educacaoInclusivaService.syncAll({
          id: parseInt(this.$route.params.matricula_id, 10),
          bimestre: parseInt(bimestre, 10),
          horario_id: horario_id ?? null,
        });

        if (response.notas) {
          this.form = response.notas;
        } else {
          this.limparCamposFormulario();
        }

        await this.carregarPlanoDoBimestre(bimestre);
      } catch (error) {
        this.$handleError(error);
      }
    },

    async carregarPlanoDoBimestre(bimestre) {
      if (bimestre === null || bimestre === undefined) {
        this.planoDoBimestre = null;
        return;
      }
      try {
        this.planoDoBimestre = await this.$services.planosBimestraisAEEService.plano(
          parseInt(this.$route.params.matricula_id, 10),
          parseInt(bimestre, 10)
        );
      } catch (error) {
        this.planoDoBimestre = null;
        this.$handleError(error);
      }
      this.descartarHorarioNaoPermitido();
    },

    descartarHorarioNaoPermitido() {
      if (!this.horarioSelecionado?.id) return;
      const permitido = this.horariosPermitidos.some(
        (horario) => horario.id === this.horarioSelecionado.id
      );
      if (!permitido) {
        this.horarioSelecionado = null;
        this.form.horario_id = null;
      }
    },

    irParaPlanoBimestral() {
      this.$router.push({
        name: "educacaoInclusiva.planoBimestralAluno",
        params: { matricula_id: this.$route.params.matricula_id },
        // sinaliza ao plano que ele deve devolver o usuário para cá após salvar
        query: { voltarPara: "atendimento", bimestre: this.form.bimestre },
      });
    },

    async onChangeHorario(item) {
      const horario_id = item.id;
      try {
        const response = await this.$services.educacaoInclusivaService.syncAll({
          id: parseInt(this.$route.params.matricula_id, 10),
          bimestre: this.form.bimestre, // Use o bimestre atual
          horario_id: horario_id ?? null,
        });

        if (response.notas) {
          this.form = response.notas;
        } else {
          this.limparCamposFormulario();
        }
      } catch (error) {
        this.$handleError(error);
      }
    },

    async loadBasicData(bimestre, horario_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        const payload = await this.$services.educacaoInclusivaService.syncAll({
          id: parseInt(this.$route.params.matricula_id, 10),
          bimestre: parseInt(bimestre, 10),
          horario_id: horario_id ?? null,
        });
        if (payload.notas && payload.notas.matricula_id === this.form.matricula_id) {
          this.form = payload.notas
            ? payload.notas
            : {
                bimestre,
                tipo_atendimento_realizado: [],
                matricula_id: parseInt(this.$route.params.matricula_id, 10),
              };
        } else {
          // Se não houver avaliação associada à matricula_id, limpar os campos do formulário
          this.limparCamposFormulario();
        }
        this.gestao_de_aulas = payload.matricula.turma.gestao_de_aulas_a_e_e;
        this.horarios = payload.horarios;
        this.horarioSelecionado = payload.notas?.horario;
        this.matricula = payload.matricula;
        this.turma = payload.matricula.turma;
        this.aluno = payload.matricula.aluno;

        if (
          this.$route.params.lancamento_id &&
          !Number.isNaN(Number(this.$route.params.lancamento_id))
        ) {
          const lancamentos = await this.$services.educacaoInclusivaService.listar(
            this.$route.params.matricula_id
          );

          const lancamentoParaEditar = lancamentos.lancamentos.find(
            (l) => l.id === Number(this.$route.params.lancamento_id)
          );

          if (lancamentoParaEditar) {
            this.form = {
              ...this.form,
              ...lancamentoParaEditar,
            };

            this.form.data = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(
              new Date(lancamentoParaEditar.data)
            );
            this.horarioSelecionado = lancamentoParaEditar.horario;
          }
        }

        await this.carregarPlanoDoBimestre(this.form.bimestre);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async submitForm() {
      let response;

      try {
        if (this.form.bimestre >= 0) {
          this.alert = false;
          this.$toast.info("Salvando relatório...");
          this.form.data = this.form.data.split("/").reverse().join("-");
          this.form.horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;
          response = await this.$services.educacaoInclusivaService.lancar(this.form);
          this.$toast.success(
            this.editing ? "Atendimento editado com sucesso!" : "Atendimento salvo com sucesso!"
          );
          this.$router.push({
            name: "educacaoInclusiva.atendimentos",
            params: { matricula_id: this.form.matricula_id },
          });
          return response;
        }
        this.alert = true;
        return this.alert;
      } catch (error) {
        this.$handleError(error);
      }
      return response;
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style></style>
